module.exports = __webpack_public_path__ + "static/media/map-marker-alt.22458424.svg";